export let AOQNNode = (function () {
    function AOQNNode(operator, left, right, field, value) {
        if (operator === void 0)
            { operator = "AND"; }
        if (left === void 0) 
            { left = undefined; }
        if (right === void 0) 
            { right = undefined; }
        if (field === void 0) 
            { field = undefined; }
        if (value === void 0) 
            { value = undefined; }
        this.field = field;
        this.operator = operator;
        this.value = value;
        this.left = left;
        this.right = right;
    }
    AOQNNode.prototype.AddLeft = function (node) {
        this.left = node;
    };
    AOQNNode.prototype.AddRight = function (node) {
        this.right = node;
    };
    return AOQNNode;
}());

export function createTree(nodeArray) {
    let jsGenerator = currentWindow(nodeArray);
    let currentObjects = jsGenerator.next();

    while(!currentObjects.done){

        let newParent = new AOQNNode();

        if(currentObjects.value.a !== undefined)
        {
            newParent.AddLeft(currentObjects.value.a);
        }
        if(currentObjects.value.b !== undefined)
        {
            newParent.AddRight(currentObjects.value.b);
        }

        nodeArray.push(newParent);

        currentObjects = jsGenerator.next();
    }

    return nodeArray.pop();
}

function* currentWindow(nodeArray) {
    let i = 0;

    while (i + 1 < nodeArray.length) {
        yield {a: nodeArray[i], b: nodeArray[i + 1]}
        i = i + 2;
    }
}